import PickerList from "components/Picker/PickerList";
import Tag from "components/Tag/Tag";
import React from "react";
import { PickerListProps } from "../props";

interface Props extends PickerListProps<server.dto.TagForList> {
  mainArea: server.dto.MainAreas;
}

const TagList = (props: Props) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedTagInstruction>({
    page: 1,
    perPage: 20,
    keyword: "",
  });

  return <>
    <PickerList
      instruction={instruction}
      onInstructionChange={setInstruction}
      queryKey="taglist"
      api={(dto: server.dto.PaginatedTagInstruction) => window.CoreApi.Tag.Paginated(dto, props.mainArea)}
      onClick={props.onItemSelected}
      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      getId={tag => tag.tagId}
      renderListItem={t => <Tag
        key={t.tagId}
        title={t.title}
        label={t.title}
        color={t.hexColor}
      />}
    />
  </>;
};

export default TagList;